// ChangeLog.jsx
import axios from "axios";
import { useEffect, useReducer, useState, useRef } from "react";
import LoadingAnimation from "../components/LoadingAnimation";
import { FaColumns, FaFilter } from "react-icons/fa";
import { BiHide } from "react-icons/bi";
import ModifyColumns from "./Tools/ModifyColumns";
import {
  Checkbox,
  FormControl,
  ListItemText,
  MenuItem,
  OutlinedInput,
  Select,
} from "@material-ui/core";
import { createStaticRanges, DateRangePicker } from "react-date-range";
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";
import { IoIosArrowDown, IoMdClose } from "react-icons/io";
import {
  addDays,
  endOfDay,
  startOfDay,
  startOfMonth,
  endOfMonth,
  addMonths,
  startOfWeek,
  endOfWeek,
  startOfYear,
  addYears,
  endOfYear,
} from "date-fns";

function ChangeLog() {
  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [showColumnsMenu, setShowColumnsMenu] = useState(false);
  const [tableVisible, setTableVisible] = useState(true);
  const [columns, setColumns] = useState([
    {
      id: "1",
      title: "Date",
      key: "date",
      visible: true,
      category: "Performance",
      locked: true,
      isLocked: true,
      type: "date",
    },
    {
      id: "2",
      title: "Changed By",
      key: "assigned_to",
      visible: true,
      category: "Performance",
      locked: true,
      isLocked: true,
      type: "boolean",
    },
    {
      id: "3",
      title: "Activity",
      key: "activity",
      visible: true,
      category: "Performance",
      type: "string",
    },
    {
      id: "4",
      title: "Change",
      key: "change_description",
      visible: true,
      category: "Performance",
      type: "string",
    },
  ]);
  const [isLoading, setIsLoading] = useState(true);
  const [dataIsNull, setDataIsNull] = useState(true);

  let ColumnRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      const isClickInsideMuiMenu = event.target.closest(
        ".groupwise-select-menu"
      );
      if (ColumnRef.current && !ColumnRef.current.contains(event.target)) {
        setShowColumnsMenu(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const openColumnsMenu = () => {
    setShowColumnsMenu(true);
  };

  const [, forceUpdate] = useReducer((x) => x + 1, 0);

  const [formVisible, setFormVisible] = useState(false);
  const [formSymbol, setFormSymbol] = useState("+");

  const [formValues, setFormValues] = useState({
    activity: "",
    campaign_ad_group: "",
    change_description: "",
    email: localStorage.getItem("email") || "",
  });

  const [filterArray, setFilterArray] = useState([]);

  useEffect(() => {
    setIsLoading(true);
    axios
      .post("https://api.confidanto.com/change-log/get", {
        email: localStorage.getItem("email"),
        project_id: localStorage.getItem("project_id"),
      })
      .then((res) => {
        setData(res.data.data);
        setFilteredData(res.data.data);
        setIsLoading(false);
        setDataIsNull(res.data.data.length === 0);
      })
      .catch(() => {
        setIsLoading(false);
        setDataIsNull(true);
      });
  }, [formVisible]);

  useEffect(() => {
    const applyFilters = () => {
      if (filterArray.length === 0) {
        setFilteredData(data);
        return;
      }

      let filtered = data.filter((item) => {
        return filterArray.every((filter) => {
          const itemValue = item[filter.key];

          switch (filter.type) {
            case "string":
              if (filter.condition === "contains") {
                return itemValue
                  .toLowerCase()
                  .includes(filter.value.toLowerCase());
              }
              if (filter.condition === "not contains") {
                return !itemValue
                  .toLowerCase()
                  .includes(filter.value.toLowerCase());
              }
              return true;

            case "boolean":
              return filter.value.includes(itemValue);

            case "date":
              const itemDate = new Date(itemValue);
              return (
                itemDate >= filter.value.startDate &&
                itemDate <= filter.value.endDate
              );

            default:
              return true;
          }
        });
      });
      setFilteredData(filtered);
    };

    applyFilters();
  }, [filterArray, data]);

  const handleFormChange = (e) => {
    setFormValues({ ...formValues, [e.target.name]: e.target.value });
  };

  const handleFormSubmit = () => {
    const { activity, campaign_ad_group, change_description, email } =
      formValues;

    if (!activity || !change_description || !email) {
      alert("All fields are required!");
      return;
    }

    axios
      .post("https://api.confidanto.com/change-log/create", {
        ...formValues,
        project_id: localStorage.getItem("project_id"),
      })
      .then((res) => {
        setFormVisible(false);
        setFormSymbol("+");
        forceUpdate();
      })
      .catch((error) => {
        console.error("Error creating change log:", error);
        alert("Something went wrong while submitting the form.");
      });
  };

  const removeFilterFromArray = (id) => {
    setFilterArray((prev) => prev.filter((fil) => fil.id !== id));
  };

  const handleSaveNavigation = () => {
    window.location.href = "/billing-support";
  };

  return (
    <div className="p-6 max-w-7xl mx-auto mb-10">
      <div className="mb-6">
        <h1 className="text-3xl font-semibold text-gray-800">Change Log</h1>
      </div>

      <div className="flex flex-row justify-between items-center">
        <FilterComponent
          columns={columns}
          data={data}
          filterArray={filterArray}
          setFilterArray={setFilterArray}
        />

        <div className="flex flex-row items-center gap-2">
          <div>
            <button
              onClick={handleSaveNavigation}
              title="save data to database"
              className="bg-green-600 text-white px-4 py-2 rounded hover:bg-green-700 transition-colors duration-200"
            >
              Save
            </button>
          </div>

          <div className="relative" ref={ColumnRef}>
            <button
              className="bg-transparent text-gray-600 px-4 py-2 rounded items-center hover:bg-slate-100"
              onClick={openColumnsMenu}
            >
              <FaColumns className="ml-5" /> Columns
            </button>
            {showColumnsMenu && (
              <ModifyColumns
                columns={columns}
                setColumns={setColumns}
                setTableVisible={setTableVisible}
                setShowColumnsMenu={setShowColumnsMenu}
              />
            )}
          </div>
        </div>
      </div>
      {filterArray.length > 0 && (
        <div className="w-full flex flex-row space-x-4 items-center p-2 relative">
          <div className="flex flex-row w-11/12 overflow-auto scroll-container">
            {filterArray.map((item) => (
              <div
                key={item.id}
                className="flex flex-row items-center justify-between p-2 border border-black rounded-lg min-w-fit mx-1"
              >
                <h2 className="mr-2">
                  {item.title} {item.sign}{" "}
                  {Array.isArray(item.value)
                    ? item.value.join(", ")
                    : item.type === "date"
                    ? `${item.value.startDate.toLocaleDateString()} - ${item.value.endDate.toLocaleDateString()}`
                    : item.value}
                </h2>
                <button onClick={() => removeFilterFromArray(item.id)}>
                  <IoMdClose />
                </button>
              </div>
            ))}
          </div>
          <div className="clearfilter flex item-center justify-center absolute right-5 text-2xl hover:bg-red-500 hover:text-white">
            <button onClick={() => setFilterArray([])}>
              <IoMdClose className="ml-5" />
            </button>
          </div>
        </div>
      )}

      <div className="bg-white rounded-md shadow-md rounded-t mb-4">
        <table className="min-w-full table-auto text-sm -mb-20 ">
          <thead className="bg-indigo-900 border-b  text-white">
            <tr className="rounded-t">
              {columns
                .filter((col) => col.visible)
                .map((col) => (
                  <th
                    key={col.key}
                    className="px-6 py-4 text-left  text-white border-r-2 border-gray-200 font-medium uppercase tracking-wider"
                  >
                    {col.title}
                  </th>
                ))}
            </tr>
          </thead>
          {!isLoading && !dataIsNull && (
            <tbody className="divide-y divide-gray-200">
              {filteredData.map((item, index) => (
                <tr
                  key={index}
                  className="hover:bg-gray-50 transition-colors duration-200"
                >
                  {columns
                    .filter((col) => col.visible)
                    .map((col) => (
                      <td
                        key={col.key}
                        className="px-6 py-4 border-r-2 border-gray-200 text-gray-700"
                      >
                        {Array.isArray(item[col.key])
                          ? item[col.key].join(", ")
                          : item[col.key]}
                      </td>
                    ))}
                </tr>
              ))}
            </tbody>
          )}
        </table>

        {isLoading ? (
          <div className="flex items-center justify-center p-10 h-[30rem]">
            <LoadingAnimation />
          </div>
        ) : dataIsNull ? (
          <div className="flex items-center justify-center p-10 h-[30rem]">
            <div className="text-lg text-gray-500">No data found</div>
          </div>
        ) : null}
      </div>

      <div className="mb-4 hidden">
        <button
          onClick={() => {
            const newVisibility = !formVisible;
            setFormVisible(newVisibility);
            setFormSymbol(newVisibility ? "-" : "+");
          }}
          className="text-white bg-indigo-900  px-5 py-2 rounded-lg text-lg shadow transition"
        >
          {formSymbol === "+" ? "Add New Log" : <BiHide />}
        </button>
      </div>

      {formVisible && (
        <form
          onSubmit={(e) => {
            e.preventDefault();
            handleFormSubmit();
          }}
          className="bg-white p-6 rounded-2xl shadow-md space-y-6"
        >
          <h2 className="text-2xl font-semibold text-gray-800 text-center">
            Add Change Log
          </h2>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Activity
            </label>
            <input
              type="text"
              name="activity"
              className="w-full border border-gray-300 rounded-md p-3 focus:outline-none focus:ring-2 focus:ring-blue-500"
              required
              onChange={handleFormChange}
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Change Description
            </label>
            <input
              type="text"
              name="change_description"
              className="w-full border border-gray-300 rounded-md p-3 focus:outline-none focus:ring-2 focus:ring-blue-500"
              required
              onChange={handleFormChange}
            />
          </div>

          <div className="text-right">
            <button
              type="submit"
              className="bg-green-600 hover:bg-green-700 text-white px-6 py-2 rounded-lg text-md shadow transition"
            >
              Submit
            </button>
          </div>
        </form>
      )}
    </div>
  );
}

const FilterComponent = ({ columns, data, filterArray, setFilterArray }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedColumn, setSelectedColumn] = useState(null);
  const [filterIdIncrement, setFilterIdIncrement] = useState(1);
  const popoverRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      const isClickInsideMuiMenu = event.target.closest(
        ".groupwise-select-menu"
      );
      if (
        popoverRef.current &&
        !popoverRef.current.contains(event.target) &&
        !isClickInsideMuiMenu
      ) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  useEffect(() => {
    if (!isOpen) {
      setSelectedColumn(null);
    }
  }, [isOpen]);

  const uniqueCategories = [
    ...new Set(columns.map((col) => col.category).filter(Boolean)),
  ];

  const handleApplyFilter = (filterObj) => {
    if (filterObj) {
      setFilterArray((prev) => [
        ...prev,
        { ...filterObj, id: filterIdIncrement },
      ]);
      setFilterIdIncrement((prev) => prev + 1);
      setIsOpen(false);
    }
  };

  const FilterSelectionView = ({
    columns,
    uniqueCategories,
    onColumnSelect,
  }) => {
    const [expandedCategory, setExpandedCategory] = useState(
      uniqueCategories[0] || null
    );

    const toggleCategory = (category) => {
      setExpandedCategory(expandedCategory === category ? null : category);
    };

    return (
      <div className="w-72">
        <h3 className="p-3 text-lg font-semibold text-gray-800 border-b border-gray-200">
          Filter by
        </h3>
        <div className="p-2 max-h-80 overflow-y-auto">
          {uniqueCategories.map((category) => (
            <div key={category} className="mb-1">
              <button
                className="flex items-center justify-between w-full p-2 text-left text-gray-700 rounded-md hover:bg-gray-100 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500"
                onClick={() => toggleCategory(category)}
              >
                <span className="font-medium">{category}</span>
                <IoIosArrowDown
                  className={`transform transition-transform duration-200 ${
                    expandedCategory === category ? "rotate-180" : ""
                  }`}
                />
              </button>
              {expandedCategory === category && (
                <div className="pl-2 mt-1 border-l-2 border-gray-200">
                  {columns
                    .filter((c) => c.category === category)
                    .map((col) => (
                      <button
                        key={col.id}
                        className="flex w-full p-2 text-sm text-left text-gray-600 rounded-md hover:bg-blue-50"
                        onClick={() => onColumnSelect(col)}
                      >
                        {col.title}
                      </button>
                    ))}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    );
  };

  const FilterInputView = ({ column, data, onApply, onBack, onClose }) => {
    const [stringValue, setStringValue] = useState("");
    const [stringCondition, setStringCondition] = useState("contains");
    const [selectedMultiOptions, setSelectedMultiOptions] = useState([]);
    const [uniqueOptions, setUniqueOptions] = useState([]);
    const [dateRange, setDateRange] = useState([
      {
        startDate: new Date(),
        endDate: new Date(),
        key: "selection",
      },
    ]);

    const definedRanges = [
      {
        label: "Today",
        range: () => ({
          startDate: startOfDay(new Date()),
          endDate: endOfDay(new Date()),
        }),
      },
      {
        label: "Yesterday",
        range: () => ({
          startDate: startOfDay(addDays(new Date(), -1)),
          endDate: endOfDay(addDays(new Date(), -1)),
        }),
      },
      {
        label: "This Week",
        range: () => ({
          startDate: startOfWeek(new Date()),
          endDate: endOfWeek(new Date()),
        }),
      },
      {
        label: "Last Week",
        range: () => ({
          startDate: startOfWeek(addDays(new Date(), -7)),
          endDate: endOfWeek(addDays(new Date(), -7)),
        }),
      },
      {
        label: "This Month",
        range: () => ({
          startDate: startOfMonth(new Date()),
          endDate: endOfMonth(new Date()),
        }),
      },
      {
        label: "Last Month",
        range: () => ({
          startDate: startOfMonth(addMonths(new Date(), -1)),
          endDate: endOfMonth(addMonths(new Date(), -1)),
        }),
      },
      {
        label: "Last 3 Months",
        range: () => ({
          startDate: startOfMonth(addMonths(new Date(), -2)),
          endDate: endOfMonth(new Date()),
        }),
      },
      {
        label: "Last 6 Months",
        range: () => ({
          startDate: startOfMonth(addMonths(new Date(), -5)),
          endDate: endOfMonth(new Date()),
        }),
      },
      {
        label: "This Year",
        range: () => ({
          startDate: startOfYear(new Date()),
          endDate: endOfYear(new Date()),
        }),
      },
      {
        label: "Last Year",
        range: () => ({
          startDate: startOfYear(addYears(new Date(), -1)),
          endDate: endOfYear(addYears(new Date(), -1)),
        }),
      },
    ];
    const staticRanges = createStaticRanges(definedRanges);

    useEffect(() => {
      if (column.type === "boolean") {
        const allValues = data.map((item) => item[column.key]);
        const uniqueVals = [...new Set(allValues.filter((v) => v != null))];
        setUniqueOptions(uniqueVals);
      }
    }, [column, data]);

    const handleApply = () => {
      let filterObj = null;
      switch (column.type) {
        case "string":
          if (!stringValue) return alert("Please enter a value.");
          filterObj = {
            title: column.title,
            key: column.key,
            condition: stringCondition,
            sign: stringCondition,
            type: "string",
            value: stringValue,
          };
          break;
        case "boolean":
          if (selectedMultiOptions.length === 0)
            return alert("Please select at least one option.");
          filterObj = {
            title: column.title,
            key: column.key,
            condition: "is one of",
            sign: "in",
            type: "boolean",
            value: selectedMultiOptions,
          };
          break;
        case "date":
          filterObj = {
            title: column.title,
            key: column.key,
            condition: "between",
            sign: "date-range",
            type: "date",
            value: dateRange[0],
          };
          break;
        default:
          return;
      }
      onApply(filterObj);
    };

    const handleClear = () => {
      setStringValue("");
      setSelectedMultiOptions([]);
    };

    const renderFilterInput = () => {
      switch (column.type) {
        case "string":
          return (
            <div className="flex items-center gap-2">
              <select
                value={stringCondition}
                onChange={(e) => setStringCondition(e.target.value)}
                className="flex-shrink-0 p-2 bg-white border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              >
                <option value="contains">Contains</option>
                <option value="not contains">Not Contains</option>
              </select>
              <input
                type="text"
                value={stringValue}
                onChange={(e) => setStringValue(e.target.value)}
                placeholder="Enter text..."
                className="w-full p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>
          );
        case "boolean":
          return (
            <FormControl fullWidth variant="outlined">
              <Select
                multiple
                displayEmpty
                value={selectedMultiOptions}
                onChange={(e) => setSelectedMultiOptions(e.target.value)}
                input={<OutlinedInput />}
                renderValue={(selected) => {
                  if (selected.length === 0) {
                    return (
                      <span style={{ color: "rgba(0, 0, 0, 0.54)" }}>
                        Select Options
                      </span>
                    );
                  }
                  return selected.join(", ");
                }}
                MenuProps={{ className: "groupwise-select-menu" }}
              >
                {uniqueOptions.map((option) => (
                  <MenuItem key={option} value={option}>
                    <Checkbox
                      checked={selectedMultiOptions.includes(String(option))}
                    />
                    <ListItemText primary={String(option)} />
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          );

        case "date":
          return (
            <DateRangePicker
              staticRanges={staticRanges}
              onChange={(item) => setDateRange([item.selection])}
              showSelectionPreview={true}
              moveRangeOnFirstSelection={false}
              months={1}
              ranges={dateRange}
              direction="horizontal"
            />
          );
        default:
          return <p>Unsupported filter type.</p>;
      }
    };

    return (
      <div className={column.type === "date" ? "w-auto" : "w-72"}>
        <div className="flex items-center justify-between p-3 border-b border-gray-200">
          <button
            onClick={onBack}
            className="p-1 text-gray-500 rounded-full hover:bg-gray-200"
          >
            &lt;
          </button>
          <h3 className="font-semibold text-gray-800">{column.title}</h3>
          <button
            onClick={onClose}
            className="p-1 text-gray-500 rounded-full hover:bg-red-100 hover:text-red-500"
          >
            X
          </button>
        </div>
        <div className="p-4 ">{renderFilterInput()}</div>
        <div className="flex justify-end gap-2 p-3 bg-gray-50 border-t border-gray-200 rounded-b-lg">
          <button
            onClick={handleClear}
            className="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50 focus:outline-none focus-visible:ring-2 focus-visible:ring-gray-400"
          >
            Clear
          </button>
          <button
            onClick={handleApply}
            className="px-4 py-2 text-sm font-medium text-white bg-blue-500 border border-transparent rounded-md hover:bg-blue-600 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500"
          >
            Apply Filter
          </button>
        </div>
      </div>
    );
  };

  return (
    <div className="flex justify-start items-start w-full">
      <div className="relative" ref={popoverRef}>
        <button
          onClick={() => setIsOpen(!isOpen)}
          className="relative flex items-center gap-2 px-4 py-2 font-medium text-gray-700 bg-white border border-gray-300 rounded-lg shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
        >
          <FaFilter className="text-gray-500" />
          <span>Filter</span>
          {filterArray.length > 0 && (
            <span className="absolute -top-2 -right-2 flex items-center justify-center w-5 h-5 text-xs font-bold text-white bg-red-500 rounded-full">
              {filterArray.length}
            </span>
          )}
        </button>

        {isOpen && (
          <div className="absolute top-full left-0 mt-2 z-50 bg-white border border-gray-200 rounded-lg shadow-xl">
            {selectedColumn ? (
              <FilterInputView
                column={selectedColumn}
                data={data}
                onApply={handleApplyFilter}
                onBack={() => setSelectedColumn(null)}
                onClose={() => setIsOpen(false)}
              />
            ) : (
              <FilterSelectionView
                columns={columns}
                uniqueCategories={uniqueCategories}
                onColumnSelect={setSelectedColumn}
              />
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default ChangeLog;
